import { Injectable,signal, computed} from '@angular/core';
import jwt_decode from 'jwt-decode';
import { AmdocsAuthService,AmdocsCookieService} from 'amdocs-core-package';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable,takeUntil,Subject} from 'rxjs';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SaveUserActivityService } from './saveUserActivity.service';
import { CONSTANTS } from '../constants';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  public promptEvent: any;
  public roleToken: string;
  public empId: string;
  public email:string;
  public employeeCode:string;
  private productLineSource = new BehaviorSubject<any | null>(null);
  private unsubscribe$: Subject<void> = new Subject<void>();
    // Navigation tracking
  private previousPage = signal<string>('');
  private currentPage = signal<string>('');
  private isPageReload = signal<boolean>(false);
  private isRedirect = signal<{ value: boolean; info?: any }>({ value: false });

  // Expose the BehaviorSubject as an observable
  currentProductLine = this.productLineSource.asObservable();  constructor(private cookieService: AmdocsCookieService, private authService: AmdocsAuthService,private saveUserAct: SaveUserActivityService
    , private http: HttpClient, private router: Router) {
    
    // Set initial value for page reload detection
    const isReloaded = this.checkIfPageReloaded();
    this.isPageReload.set(isReloaded);
    console.log('Page reload detected on initialization:', isReloaded);
    
    // Track NavigationStart events to capture the previous page before navigation
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe((event: NavigationStart) => {
      // Store the current page as previous before navigation starts
      const currentPageName = this.getPageNameFromPath(this.router.url);
      if (currentPageName) {
        this.previousPage.set(currentPageName);
      }
    });
    
    // Track NavigationEnd events to capture the current page after navigation
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // Update the current page after navigation completes
      const currentPageName = this.getPageNameFromPath(event.urlAfterRedirects);
      this.currentPage.set(currentPageName);
      
      // Reset the page reload flag after navigation completes
      if (this.isPageReload()) {
        this.isPageReload.set(false);
      }
    });
  }

  private name = '';

  /**
   * Checks if the current page load is a result of a reload
   */
  private checkIfPageReloaded(): boolean {
    try {
      const navEntries = performance.getEntriesByType('navigation');
      if (navEntries.length > 0) {
        const navigation = navEntries[0] as PerformanceNavigationTiming;
        return navigation.type === 'reload';
      }
      
      // Fallback for older browsers
      return window.performance && 
             window.performance.navigation && 
             window.performance.navigation.type === window.performance.navigation.TYPE_RELOAD;
    } catch (error) {
      console.error('Error checking page reload status:', error);
      return false;
    }
  }
  
  /**
   * Extracts the page name from a path
   * @param path The path to extract the page name from
   * @returns The page name
   */  private getPageNameFromPath(path: string): string {
    if (!path) return '';
    
    // Remove query string if present
    const pathWithoutQuery = path.split('?')[0];
    
    const segments = pathWithoutQuery.split('/').filter(segment => segment);
    const pageName = segments.length > 0 ? segments[segments.length - 1] : 'home';
    
    // Capitalize first letter if needed
    if (pageName.length > 0) {
      const firstCharCode = pageName.charCodeAt(0);
      if (firstCharCode >= 97 && firstCharCode <= 122) {
        return String.fromCharCode(firstCharCode - 32) + pageName.slice(1);
      }
    }
    
    return pageName;
  }

  public setUserDetails(): void {
    const formattedToken: any = jwt_decode(this.authService.getToken());
    this.name = formattedToken['name'] ? formattedToken['name'] : '';
    this.empId = formattedToken['iat'] ? formattedToken['iat'] : '';
  }

  public getName(): string {
    const formattedToken: any = jwt_decode(this.authService.getToken());
    this.name = formattedToken['name'] ? formattedToken['name'] : '';
    return this.name;
  }

  public getEmail(): string {
    const formattedToken: any = jwt_decode(this.authService.getToken());
    this.email = formattedToken['preferred_username'] ? formattedToken['preferred_username'] : '';
    return this.email;
  }

  public getUpn():string {
    const formattedToken: any = jwt_decode(this.authService.getToken());
    const upn = formattedToken['upn'] ? formattedToken['upn'] : '';
    return upn;
  }

  public getEmployeeCode(): string {
    const formattedToken: any = jwt_decode(this.authService.getToken());
    this.employeeCode = formattedToken['Employee-ID'] ? formattedToken['Employee-ID'] : '';
    return this.employeeCode;
  }
  public getEmpId(): string {
    return this.empId;
  }
  



  // Method to update the product line
  setProductLine(productLine: string) {
    this.productLineSource.next(productLine);
  }  /**
   * Returns the statistics input object with the current and previous page information
   * @param data Additional data for the statistics input
   * @returns The statistics input object
   */  getStatsticsInput(data): any {
    // Get current navigation state
    let currentPageName = data.currentPageName || this.getCurrentPage();
    
    // For landing page, prioritize:
    // 1. Explicitly provided landing page from the payload (highest priority)
    // 2. "Reloaded" if the page was reloaded
    // 3. Previous page if available 
    // 4. Empty string as fallback
    // let landingPage = '';
    // if (data && data.landingPage) {
    //   landingPage = data.landingPage;
    // } else if (this.isPageReloaded()) {
    //   landingPage = 'PageLoad';
    // } else if (this.getPreviousPage()) {
    //   landingPage = this.getPreviousPage();
    // }
  
    // Create the statistics input object
    const statisticsInput: any = {
      "apsSessionId":sessionStorage.getItem(CONSTANTS.SessionSTORAGE.SOSessionID)?sessionStorage.getItem(CONSTANTS.SessionSTORAGE.SOSessionID):'',
      "eventType":data.eventType ? data.eventType : CONSTANTS.STATISTICS.Activity,
      "actionType":this.isRedirect().value ? this.isRedirect().info : '',
    };

    if(data && data.inPage != CONSTANTS.STATISTICS.ExcludedParam){
      if(currentPageName=="Searchresults"){
        currentPageName = CONSTANTS.STATISTICS.SearchResults;
      }
      if(currentPageName=="Home"){
        currentPageName = CONSTANTS.STATISTICS.Home;
      }
      if (data.inPage=='Home') {
        data.inPage = CONSTANTS.STATISTICS.Home;
      }
      // Use provided inPage, or fallback to current page
      statisticsInput["inPage"] = data.inPage ? data.inPage : currentPageName;
    }

    // Process data properties using switch statement
    if (data) {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          switch (key) {
            case 'actionType':
              if (data.actionType) {
                statisticsInput["actionType"] = data.actionType;
              }
              break;
            case 'clickTime':
              if (data.clickTime) {
                statisticsInput["clickTime"] = data.clickTime;
              }
              break;
            case 'clickType':
              if (data.clickType) {
                statisticsInput["clickType"] = data.clickType;
              }
              break;
            case 'landingPage':
              if (data.landingPage != CONSTANTS.STATISTICS.ExcludedParam) {
                statisticsInput["landingPage"] = data.landingPage ? data.landingPage : currentPageName;
              }
              break;
            case 'searchQueryId':
              if (data.searchQueryId && data.searchQueryId !== '') {
                statisticsInput["searchQueryId"] = data.searchQueryId;
              }
              break;
            case 'searchSaved':
              if (data.searchSaved && data.searchSaved !== '') {
                statisticsInput["searchSaved"] = data.searchSaved;
              }
              break;
            case 'pageNo':
              if (data.pageNo && data.pageNo !== '') {
                statisticsInput["pagination"] = data.pageNo;
              }
              break;
            case 'oldValue':
              if (data.oldValue) {
                statisticsInput["oldValue"] = data.oldValue;
              }
              break;
            case 'newValue':
              if (data.newValue) {
                statisticsInput["newValue"] = data.newValue;
              }
              break;
            case 'created':
              if (data.created) {
                statisticsInput["created"] = data.created;
              }
              break;
            case 'searchQueryCreationTime':
              if (data.searchQueryCreationTime) {
                statisticsInput["searchQueryCreationTime"] = data.searchQueryCreationTime;
              }
              break;
            case 'clickNumber':
              if (data.clickNumber) {
                statisticsInput["clickNumber"] = data.clickNumber;
              }
              break;
            case 'clickPosition':
              if (data.clickPosition) {
                statisticsInput["clickPosition"] = data.clickPosition;
              }
              break;
            case 'FileS':
              if (data.FileS) {
                statisticsInput["FileS"] = data.FileS;
              }
              break;
            case 'ResultID':
              if (data.ResultID) {
                statisticsInput["ResultID"] = data.ResultID;
              }
              break;
            case 'ResultEntityID':
              if (data.ResultEntityID) {
                statisticsInput["ResultEntityID"] = data.ResultEntityID;
              }
              break;
            case 'DocumentAvailableResources':
              if (data.DocumentAvailableResources) {
                statisticsInput["DocumentAvailableResources"] = data.DocumentAvailableResources;
              }
              break;
            case 'pagination':
                if (data.pagination) {
                  statisticsInput["pagination"] = data.pagination;
                }
              break;  
          }
        }
      }
    }
    
    return statisticsInput;
  } 
  
  saveUserActivity(activityPayload): void {
      
      const statsData=this.getStatsticsInput(activityPayload);
      console.log('Saving user activity with data:', statsData);
      
      this.saveUserAct.saveUserActivity(statsData)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
        next: (response) => {
         console.log('User activity saved successfully:', response);
        },
        error: (error) => {
          // handle error if needed
          console.error('Error saving user activity:', error);
        }
        });
    }

    /**
   * Returns the current page name
   * @returns The current page name
   */
  public getCurrentPage(): string {
    return this.currentPage();
  }

  /**
   * Returns the previous page name
   * @returns The previous page name
   */
  public getPreviousPage(): string {
    return this.previousPage();
  }
  /**
   * Returns whether the page was reloaded
   * @returns True if the page was reloaded, false otherwise
   */
  public isPageReloaded(): boolean {
    return this.isPageReload();
  }
  

  public setRedirect(value: boolean, redirectInfo?: any): void {
    this.isRedirect.set({ value, info: redirectInfo });
  }
  


}
